<template>
  <div class="cx_sidebar">
    <b-nav vertical>
      <!-- <SideBarGroup title="クイックメニュー" :accordion="accordion" v-if="sharedItems.length > 0">
        <template slot-scope="{parent}">
          <SideBarItem class="item" v-for="(item,index) in sharedItems" :key="index" :to="getPath2(index)" :icon="item.icon" :indent="2" :iconColor="item.iconColor" :parent="parent" :title="item.name"/>
        </template>>
      </SideBarGroup> -->
      <!-- お気に入り -->
      <!-- <SideBarGroup title="お気に入り" :accordion="accordion" v-if="items.length > 0">
        <template slot-scope="{parent}">
          <SideBarItem class="item" v-for="(item,index) in items" :key="index" :to="getPath(index)" :icon="item.icon" :indent="2" :iconColor="item.iconColor" :parent="parent" :title="item.name"/>
        </template>
      </SideBarGroup> -->
      <slot></slot>
    </b-nav>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import * as Common from '@/agiles/common';
import * as Components from '@/agiles/components';


@Component
export default class SideBar extends Vue {
  @Prop() public path: string;
  @Prop() public defaultRoute: string;
  @Prop() public accordion: string;
  public items: Common.Favorite[] = new Array(0);
  public sharedItems: Common.Favorite[] = new Array(0);
  public message: string = '';
  public showDialog: boolean = false;
  public created() {
    this.$root.$on('sidebar', this.reload);
  }
  public beforeMount() {
    this.reload();
  }

  public reload() {
    //お気に入りをロードする
    if (this.path != undefined) {

      // const query = new Common.FavoriteQuery(Common.favoriteFlags.Private);
      // query.path = this.path;
      // this.$api.execute(query).then(res => {
      //   const temp = res as Common.LoadResult;        
      //   this.items = temp.result;
      //   this.$forceUpdate();
      // });

      // const queryShared = new Common.FavoriteQuery(Common.favoriteFlags.System);
      // queryShared.path = this.path;
      // this.$api.execute(queryShared).then(res => {
      //   const temp = res as Common.LoadResult;
      //   this.sharedItems = temp.result;
      //   this.$forceUpdate();
      // });

      const query = new Common.FavoriteQuery(Common.favoriteFlags.All);
      query.path = this.path;
      this.$api.execute(query).then(res => {
        const temp = res as Common.LoadResult;        
        this.items = temp.result;
        //ここでスロット内のSideBarGroupを検索して詰めていく
        if (this.$scopedSlots.default)
        {
          this.$scopedSlots.default(null).forEach(node =>{
            if (node.componentInstance instanceof Components.SideBarMenuItem){
              var menu = node.componentInstance as Components.SideBarMenuItem;

              menu.$on('selected',this.onSelected);         
              this.$nextTick(()=>{
                  if (this.$route.fullPath == menu.to) this.onSelected(menu);
              });
              //menu.toと同じパスを持つ項目を追加する
              var path = menu.to;
              if (path.indexOf("?") > -1)path = path.substring(0, menu.to.indexOf("?"));
              var targets = new Array();
              this.items.forEach(obj => {
                if (obj.path == path)targets.push(obj);
              });
              menu.items = targets;
            }
          });

        }
        this.$forceUpdate();
      });      
    }
  }

  lastCollapsed : Components.SideBarMenuItem;
  public onSelected(menu : Components.SideBarMenuItem){
    if (menu.opened == false){
      //前回のメニューを閉じる
      if (this.lastCollapsed && this.lastCollapsed.opened) this.lastCollapsed.collapse();
      this.lastCollapsed = menu;
      this.lastCollapsed.collapse();
    }
    //お気に入りのカウントを集計する
    if (menu.query){
      this.$api.execute(new Common.CountQuery(menu.items.map(obj =>JSON.parse(obj.json)),menu.query)).then(results =>{
        menu.items.forEach((item,index) => item.count = results[index]);
      });
    }    

  }
  public getPath(index: number) {
    const item = this.items[index];
    return item.path + '?favorite=' + item.key;
  }

  public getPath2(index: number) {
    const item = this.sharedItems[index];
    return item.path + '?favorite=' + item.key;
  }

}
</script>
<style  lang="scss">
.cx_sidebar {
  flex: 1;
  overflow-y: auto;
  /* min-width: 230px; */
  /* width: 300px; */
  margin: 0;
  padding: 0;
  /* background-color: #dadbd1; */
  background-color:#ececec;

  height: 100%;
  padding-top: 50px;
  overflow-x: hidden;
  font-size:14px;

  .cx_sidebar_splitter{
    display: block;
    height: 1px;
    border: 0;
    border-top: 1px solid #ccc;
    box-shadow: 0 1px #fff;    
    margin: 10px 0;
    padding: 0;
    width: 80%;
    margin-left: 10%;
  }
}

.cx_sidebar_spacer {
  height: 50px;
}
</style>